type BrandLockupProps = {
  compact?: boolean;
};

export function BrandLockup({ compact = false }: BrandLockupProps) {
  return <span className={`brand-lockup${compact ? " compact" : ""}`}>
    <span className="brand-symbol" aria-hidden="true">
      <svg viewBox="0 0 32 32" role="img">
        <path d="M16 3.5 26 7v7.2c0 6.3-4.1 11.5-10 14.3C10.1 25.7 6 20.5 6 14.2V7l10-3.5Z" />
        <path className="brand-check" d="m11.2 15.8 3.1 3.1 6.7-7" />
      </svg>
    </span>
    <span>ClearGuard</span>
  </span>;
}
